import api from "../../../services/api";

// Opções reais dos filtros de cliente/equipamento do dashboard ("fase 4"):
// clientes do escopo de permissão do usuário e seus hosts monitorados, com
// nome resolvido no Zabbix. Independe do período — buscado uma vez por
// montagem da página (o backend cacheia por usuário).
//
// Shape: { clientes: [{ id, nome }], equipamentos: [{ id, nome, clienteId }] }
// — `id` do equipamento é o hostId do Zabbix, mesmo valor enviado em
// filterEquipamentos para as demais rotas.
export async function buscarFiltrosDashboard({ signal }) {
	const resposta = await api.post("/find/centralAlertas/filtros", {}, { signal });
	return {
		clientes: resposta?.data?.clientes || [],
		equipamentos: resposta?.data?.equipamentos || [],
	};
}
